// extracted by mini-css-extract-plugin
export default {"overlay":"qy-z","bodyOpen":"ry-z","content":"sy-z","header":"ty-z","close":"uy-z","closeNoHeading":"vy-z"};